import { useState, useEffect, useCallback } from 'react';

interface Account {
  id: number;
  customer_id: string;
  name: string;
  is_default: boolean;
}

interface AccountSelectorProps {
  selectedAccountId: string;
  onAccountChange: (accountId: string, accountName: string) => void;
  disabled?: boolean;
}

export default function AccountSelector({ selectedAccountId, onAccountChange, disabled }: AccountSelectorProps) {
  const [accounts, setAccounts] = useState<Account[]>([]);

  const loadAccounts = useCallback(async () => {
    try {
      const res = await fetch('/api/accounts');
      if (res.ok) {
        const data = await res.json();
        setAccounts(data.accounts || []);
      }
    } catch {}
  }, []);

  useEffect(() => {
    loadAccounts();
  }, [loadAccounts]);

  useEffect(() => {
    if (accounts.length === 1 && (!selectedAccountId || selectedAccountId !== accounts[0].customer_id)) {
      onAccountChange(accounts[0].customer_id, accounts[0].name || '');
    }
  }, [accounts, selectedAccountId, onAccountChange]);

  if (accounts.length === 0) return null;

  if (accounts.length === 1) {
    return (
      <span
        className="command-bar-select command-bar-account-select command-bar-account-readonly"
        title="Active account"
      >
        {accounts[0].name || accounts[0].customer_id}
      </span>
    );
  }

  return (
    <select
      className="command-bar-select command-bar-account-select"
      value={selectedAccountId}
      onChange={(e) => {
        const acct = accounts.find((a) => a.customer_id === e.target.value);
        onAccountChange(e.target.value, acct?.name || '');
      }}
      disabled={disabled}
      title="Switch account"
    >
      {accounts.map((a) => (
        <option key={a.customer_id} value={a.customer_id}>
          {a.name || a.customer_id}
        </option>
      ))}
    </select>
  );
}
